/**
 * Plan tier helpers + feature entitlements.
 *
 * The wire format for `event.plan` is the lowercase tier id (`free`, `basic`,
 * `pro`) as defined in api/models.mjs.
 *
 * The tier predicates (`isProPlan`, `isPaidPlan`) answer "which tier is this?" —
 * use them for billing and pricing UI. The capability predicates below answer
 * "may this plan use feature X?" — use those for feature gating, so moving a
 * feature between tiers stays a one-line change here.
 *
 * The capability predicates MIRROR api/constants/planFeatures.mjs, which is the
 * enforcement boundary; these only hide nav entries and surfaces the backend
 * would 403 anyway. Keep the two in lockstep, same as the message-code
 * registries.
 */

export const isProPlan = (plan?: string | null): boolean => plan === 'pro';

export const isPaidPlan = (plan?: string | null): boolean => plan === 'basic' || plan === 'pro';

/**
 * Editorial invitation product — `invite/`, RSVP, guest list, event sections,
 * seating, Planning Hub, Éros. Heirloom only.
 */
export const hasInvitationProduct = (plan?: string | null): boolean => isProPlan(plan);

/** Private video wishes from guests. Bouquet + Heirloom. */
export const canUseWishes = (plan?: string | null): boolean => isPaidPlan(plan);

/** Guest quiz + leaderboard. Bouquet + Heirloom. */
export const canUseQuiz = (plan?: string | null): boolean => isPaidPlan(plan);

/** Take the Agapaé credit off the printable QR table card. Bouquet + Heirloom. */
export const canHideCardCredit = (plan?: string | null): boolean => isPaidPlan(plan);
